/** @jsx jsx */
import {jsx, css} from '@emotion/core';
import {makeStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Badge from '@material-ui/core/Badge';

const server = 'https://infinite-dusk-89390.herokuapp.com';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  buttonBlue: {
    background: 'linear-gradient(45deg, #2196f3 30%, #21cbf3 90%)',
  },
  buttonRed: {
    background: 'linear-gradient(45deg, #FF0000 30%, #BB0000 90%)',
  },
}));

export default ({showItem, setShowItem, count, setCount, id, name}) => {
  const classes = useStyles();

  const css_item = css`
    background-color: ${showItem === id ? '#d2d2d2' : 'white'};
    break-inside: avoid-column;
    margin: auto;
    box-shadow: 0 0 0 0.01px white;
    border-radius: 10px;
    position: relative;

    :hover {
      ${showItem === id ? '' : 'box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.25);'}
      cursor: pointer;
    }

    .base {
      padding: 10px;
    }

    .h {
      text-align: center;
    }

    .img {
      border: 2px solid black;
      border-radius: 10px;
      filter: drop-shadow(0 0 10px #888);
      height: 80px;
      width: 80px;
      image-rendering: pixelated;
      image-rendering: -moz-crisp-edges;
      image-rendering: crisp-edges;
      padding: 10px;
      display: block;
      margin: auto;
      ${showItem === id ? 'filter: alpha(opacity=40);' : ''}
    }

    .p {
      text-align: center;
      margin: 10px;
    }

    #a${id} {
      display: block;
    }

    #a${id}:hover + #b${id} {
      display: block;
    }

    #b${id} {
      display: none;
      position: absolute;
      bottom: 5px;
      right: 5px;
    }

    #b${id}:hover {
      display: block;
    }
  `;

  const sendId = () => setShowItem(id);

  return (
    <div css={css_item} className={classes.root}>
      <div id={`a${id}`} className="base">
        <Badge color="secondary" badgeContent={count}>
          <img
            className="img"
            onClick={sendId}
            src={`${server}/tiles/${id}`}
            alt={name}
          />
        </Badge>
      </div>
      <div id={`b${id}`}>
        {count !== 0 ? (
          <IconButton
            className={classes.buttonRed}
            size="small"
            id={`minus${id}`}
            onClick={() => {
              setCount(id, -1);
            }}
          >
            <RemoveIcon fontSize="small" />
          </IconButton>
        ) : (
          ''
        )}

        <IconButton
          className={classes.buttonBlue}
          size="small"
          id={`add${id}`}
          onClick={() => {
            setCount(id, 1);
          }}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
};
